export const Development = [
        {
            'Tech': 'Frontend',
            'data': [
                {
                    'name': 'Frontend Framework/Library (Reactjs)'
                },
                {
                    'name': 'Responsive Web Design'
                },
                {
                    'name': 'HTML/CSS Markup'
                },
                {
                    'name': "Designing Using CSS"
                },
                {
                    'name': 'Javascript'
                }
                    ]
        },

        {
            'Tech': 'Backend',
            'data': [
                { name: 'API Development' },
                { name: 'Server-Side Programming' },
                { name: 'Database Management' },
                { name: 'Web Framework (Django)' },
                { name: 'Rest Framework' },
                { name: 'Authentication and Authorization' },
                { name: 'Data Validation and Sanitization' },
                { name: 'Performance Optimization' },
                { name: 'Server Deployment' },
                { name: 'Error Handling and Logging' },
                { name: 'Testing and Debugging' },
                { name: 'API Documentation' },
                { name: 'Security' },
                { name: 'Performance Monitoring' },
                { name: 'Integration with Third-Party Services' }
              ]
        },

        {
            'Tech': 'Machine Learning',
            'data': [
                {
                    'name': 'Creating Predicting Models using Scikit-Learn'
                },
                {
                    'name': 'Creating Predicting Models of deep learning'
                },
                {
                    'name': 'Data Refining'
                },
                {
                    'name': 'Optimising Models for Better Accuracy'
                },
            ]
        }
            ]

// export const BackendDevelopment = [
//     { name: 'API Development' },
//     { name: 'Server-Side Programming' },
//     { name: 'Database Management' },
//     { name: 'Web Frameworks' },
//     { name: 'Authentication and Authorization' },
//     { name: 'Data Validation and Sanitization' },
//     { name: 'Caching and Performance Optimization' },
//     { name: 'Server Deployment and Infrastructure' },
//     { name: 'Error Handling and Logging' },
//     { name: 'Testing and Debugging' },
//     { name: 'API Documentation' },
//     { name: 'Security' },
//     { name: 'Performance Monitoring' },
//     { name: 'Integration with Third-Party Services' }
//   ];

// export const MachinLearningDevelopment = [
//     {
//         'name': 'Creating Predicting Models using Scikit-Learn'
//     },
//     {
//         'name': 'Creating Predicting Models of deep learning'
//     },
//     {
//         'name': 'Data Refining'
//     },
//     {
//         'name': 'Optimising Models for Better Accuracy'
//     },
// ]